export default "__VITE_ASSET__CuRrMIpp__"